"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalManager = void 0;
var PortalManager = /** @class */ (function () {
    function PortalManager(portals, setPortals) {
        this.portals = portals;
        this.setPortals = setPortals;
    }
    PortalManager.prototype.openPortal = function (portal) {
        this.setPortals(__spreadArrays(this.portals, [portal]));
        return portal;
    };
    PortalManager.prototype.closePortal = function (portal) {
        this.setPortals(this.portals.filter(function (item) { return item !== portal; }));
    };
    PortalManager.prototype.getPortals = function () {
        return this.portals;
    };
    PortalManager.getPortalCount = function () {
        PortalManager.portalCount++;
        return PortalManager.portalCount;
    };
    PortalManager.portalCount = 0;
    return PortalManager;
}());
exports.PortalManager = PortalManager;
//# sourceMappingURL=PortalManager.js.map